import { IStoreRouterState } from './router.interface';

export default {
  activeRoute: undefined,
  insideModal: false,
  modalsOpened: [],
} as IStoreRouterState;
